const AUTH_ERROR_KEY = "lio_quest_auth_error";

/** Stash a one-shot message shown on the next visit to /login. */
export function setAuthFlash(message: string) {
  if (typeof window === "undefined") return;
  const trimmed = message.trim();
  if (!trimmed) return;
  sessionStorage.setItem(AUTH_ERROR_KEY, trimmed);
}

/** Read and clear the one-shot login error, if any. */
export function consumeAuthFlash(): string | null {
  if (typeof window === "undefined") return null;
  const message = sessionStorage.getItem(AUTH_ERROR_KEY);
  if (message) sessionStorage.removeItem(AUTH_ERROR_KEY);
  return message?.trim() || null;
}
